import { Flex, Typography, theme } from "antd";

const { Title } = Typography;

const SectionHeader: React.FC<{ title: string }> = ({ title }) => {
   const { token } = theme.useToken();
   return (
      <Flex align="center" gap={10} style={{ marginBottom: 4 }}>
         <div
            style={{
               width: 5,
               height: 24,
               borderRadius: 99,
               background: token.colorPrimary,
               flexShrink: 0,
            }}
         />
         <Title level={5} style={{ margin: 0, fontWeight: 800, fontSize: 17 }}>
            {title}
         </Title>
      </Flex>
   );
};

export default SectionHeader;